"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isValid = function (value) {
    var errors = {
        passwordRequiredContent: 'Senha requer ao menos 1 letra e 1 número',
        passwordRequiredSize: 'Senha requer tamanho entre 8 e 60 símbolos',
    };
    var HAS_REQUIRED_CONTENT = /^(?=.*[a-zA-Z])(?=.*\d)/.test(value);
    var HAS_REQUIRED_SIZE = /^.{8,60}$/.test(value);
    if (HAS_REQUIRED_CONTENT) {
        if (HAS_REQUIRED_SIZE) {
            return {
                hasError: false,
                message: '',
            };
        }
        else {
            return {
                hasError: true,
                message: errors.passwordRequiredSize,
            };
        }
    }
    else {
        return {
            hasError: true,
            message: errors.passwordRequiredContent,
        };
    }
};
var validatePasswordRequirements = function (value) {
    var validationResult = isValid(value);
    if (validationResult.hasError)
        return validationResult.message;
    return false;
};
exports.default = validatePasswordRequirements;
//# sourceMappingURL=passwordRequirements.js.map